module.exports = __webpack_public_path__ + "img/icon_listmytools_step3_rates.72c95f21.svg";